import { MerchantType } from 'server/models/Merchant';
import { IUserType } from 'server/models/User';
import { ISelectorOption } from 'types/ISelectorOption';

export const getMerchantOptions = (merchants: IUserType[]): ISelectorOption[] =>
  merchants.map((el) => ({
    label: (el.merchantId as MerchantType)?.shopName,
    value: (el.merchantId as MerchantType)?._id,
  }));
